import { Routes, Route, useRouteError } from 'react-router-dom';
import GameContainer from './Pages/GameContainer/GameContainer';
import ErrorPage from './Pages/404/error';
import AdminPage from './Pages/Admin/AdminPage';

const App = () => {
 return (
    <>
       <Routes>
         <Route path='/admin' element={<AdminPage />}/>
          <Route path="*" element={<GameContainer />} />
       </Routes>
    </>
 );
};

export default App;